"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const core_1 = require("../core");
const BlueprintBlock_1 = require("./BlueprintBlock");
let BlueprintTemplate = class BlueprintTemplate extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => core_1.OsmosysResource),
    typeorm_1.OneToOne(() => core_1.OsmosysResource, {
        cascade: true,
        onDelete: 'CASCADE',
    }),
    tslib_1.__metadata("design:type", Object)
], BlueprintTemplate.prototype, "resource", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => core_1.OsmosysResource),
    typeorm_1.OneToOne(() => core_1.OsmosysResource, {
        cascade: true,
        nullable: true,
        onDelete: 'CASCADE',
    }),
    tslib_1.__metadata("design:type", Object)
], BlueprintTemplate.prototype, "adTemplate", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [BlueprintBlock_1.BlueprintBlock]),
    typeorm_1.OneToMany(() => BlueprintBlock_1.BlueprintBlock, block => block.template),
    tslib_1.__metadata("design:type", Object)
], BlueprintTemplate.prototype, "blocks", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], BlueprintTemplate.prototype, "html", void 0);
BlueprintTemplate = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], BlueprintTemplate);
exports.BlueprintTemplate = BlueprintTemplate;
//# sourceMappingURL=BlueprintTemplate.js.map